import * as tslib_1 from "tslib";
import { CustomerActionTypes } from './types';
var initialState = {
    user: null,
    bookmarks: null,
    bookmarkLists: null,
    products: null,
    type: CustomerActionTypes.INITIAL_STATE
};
var reducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case CustomerActionTypes.CUSTOMER_LOGIN_ANONYMOUS:
        case CustomerActionTypes.CUSTOMER_LOGIN:
        case CustomerActionTypes.CUSTOMER_BOOKMARK_ACTION:
            return tslib_1.__assign({}, state, action);
        default: {
            return state;
        }
    }
};
export { reducer as customerReducer };
